import type { FaireProductEntity } from "../../entity_types/product";

export const p_6vrmumuh56: FaireProductEntity = {
  token: "p_6vrmumuh56",
  type: "product",
  name: "Paxton's Plaid Newborn Baby Knot Gown & Hat Set",
  brandToken: "b_rmanzshebs",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/afdcba72beb3a6a5a89a62eaa6ac4096cd7019b6463749f074c63d7760b006cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6711d169ef9a3a4859574f8f32fd0c30e39886a8826c083ab14f025211805a33.jpeg",
    "https://cdn.faire.com/fastly/bee6583c15736913125907452d7a87f934e66547c0f414957fd8db9a7c18bde1.jpeg",
    "https://cdn.faire.com/fastly/4c1fa415a8bb1b402d08d3fa1e288b77dea443b7a7b8c12ebae225bc54e4aad3.jpeg",
    "https://cdn.faire.com/fastly/bc584cf990ae6f78e96850b92ce28f1dc6af941d1943509c721f0e59169d6bb4.jpeg",
    "https://cdn.faire.com/fastly/9db0bb7b7d6559779181e50f4f4a91a9595614df1244dc41e179857a0f0ae961.jpeg",
  ],
  priceDollars: 18,
  description:
    "Let this blue plaid knot gown be your baby's very first outfit on Earth and watch everyone drool over your handsome boy! This knot gown is the perfect outfit to introduce your baby to world in and will be the star of your newborn photoshoot, all while keeping your little one as comfy as can be. This gown is also great for everyday use, with the convenient self-tying knot that makes diaper changes easier than ever before without disturbing your baby.\n\nKnot Gown Details: \n\n * Size 0-3 Months - Approximately 27\" long \n * 95/5% - Poly/Spandex \n * Leg opening at the bottom makes for an easy diaper change, then simply tie in a knot for a secure fit \n * Includes: 1 Gown + 1 Matching Printed Hat \nCare Instructions:\n\n * Machine Wash Cold - Gentle Cycle \n * Phosphate Free Detergent Recommended for Color Care \n * Line Dry / Air Fluff \n * Do NOT use Fabric Softener\nAll sales are subject to MAAP agreement found here: https://cadenlane.com/pages/wholesale-maap-online-agreement",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:31.127Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
